import { Component } from 'react'
import type { ErrorInfo, ReactNode } from 'react'

interface State {
  hasError: boolean
}

export class ErrorBoundary extends Component<{ children: ReactNode; fallback?: ReactNode }, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[boundary]', error, info)
    window.setTimeout(() => {
      if (this.state.hasError) window.location.reload()
    }, 30_000)
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div className="grid h-screen w-screen place-items-center bg-surface-0 text-center text-ink">
            <div className="space-y-3">
              <h1 className="text-3xl font-display font-semibold">⚠️</h1>
              <p className="text-ink-muted">Něco se rozsypalo. Obnovujeme za chvíli…</p>
            </div>
          </div>
        )
      )
    }
    return this.props.children
  }
}
